<div *ngIf="imageID === 0; else productImage"
    class="d-flex align-items-center">
    <div class="product-image-order-management no-image-order-management-background">
        <svg class="no-image-image">
            <use href="../App_Themes/CXone/icons/not-available-image.svg#not-available-image"></use>
        </svg>
    </div>
    <span #textStatus class="text-wrapper" [matTooltip]="isTextHasEllipsis(textStatus) ? title : undefined" matTooltipClass="custom-tooltip-product" matTooltipPosition="after">
        {{title}}
    </span>
</div>
<ng-template #productImage>
    <div class="d-flex align-items-center">
        <img [src]="imageURL" class="product-image-order-management" />
        <span #textStatus class="text-wrapper" [matTooltip]="isTextHasEllipsis(textStatus) ? title : undefined" matTooltipClass="custom-tooltip-product">
            {{title}}
        </span>
    </div>
</ng-template>
